var React = require('react');

function ChartLine (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-100.979 -31.224)"},[React.createElement("path",{"d":"M176.982,115.319h-76v16.138h76a8.07,8.07,0,0,0,0-16.138Z","transform":"translate(0 16.767)","fill":"#00c0df","key":0}),React.createElement("path",{"d":"M111.612,70.6,135.8,91.421c.088.076.177.15.268.221h0a7.951,7.951,0,0,0,11.2-1.36L183.256,44.3a8.117,8.117,0,0,0-1.325-11.338l-.032-.025a7.951,7.951,0,0,0-11.2,1.359L139.855,73.705,116.181,53.327a7.947,7.947,0,0,0-11.027.619l-4.176,4.494v23.6Z","transform":"translate(0 0)","fill":"#b7edf6","style":{"isolation":"isolate"},"key":1})]));
}

ChartLine.defaultProps = {"width":"84","height":"117.001","viewBox":"0 0 84 117.001"};

module.exports = ChartLine;

ChartLine.default = ChartLine;
